//eslint-disable-next-line
import React, { useEffect, useState, Component } from "react";


// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Table,
  Row,
  Col
} from "reactstrap";


// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";
import axios from "axios";
import { api_link } from "siteConfig";
import { NavLink } from "react-router-dom";

class Dashboard extends Component {

  constructor(props) {
    super(props);

    this.state = {
      stats: [],
      blog: [],
      contacts: []
    };
  }

  componentDidMount() {

    // console.log("Dashboard Mounted");

    try {
      this.loadStats(sessionStorage.getItem("site_ids"));
      this.loadContacts(sessionStorage.getItem("site_ids"));
      this.loadBlog();
    } catch (error) {
      console.error("Error in componentDidMount:", error);
    }

    // Set interval to reload stats every 5 seconds
    this.interval = setInterval(() => {

      try {
        if (sessionStorage.getItem("statsLoaded") === "0") {
          this.loadStats(sessionStorage.getItem("site_ids"));
        }

        if (sessionStorage.getItem("contactsLoaded") === "0") {
          this.loadContacts(sessionStorage.getItem("site_ids"));
        }
      } catch (error) {
        console.error("Error in interval:", error);
      }

    }, 100000);

  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  loadStatsData = (sites) => {
    let url = 'https://' + api_link + 'customer_portal_v2/getStats';

    return axios({
      method: "post",
      url: url,
      data: {
        "referurl": url,
        "var1": sites
      },
      timeout: 5000,
      headers: {
        "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // Handle any errors that occur during the API request
      });
  }

  loadStats = (siteIds) => {

    // console.log("Stats Loading");

    this.loadStatsData(siteIds)
      .then(statsData => {
        if (Array.isArray(statsData)) {
          this.setState({ stats: [...statsData] });
        } else {
          // Handle the case when statsData is not iterable
          console.error("statsData is not iterable");
        }
      })
      .catch(error => {
        // Handle any errors that occur during the API request
        console.error("Error loading stats:", error);
      });

    // sessionStorage.setItem("statsLoaded", 1);

  }

  loadContactsData = (sites) => {
    let url = 'https://' + api_link + 'customer_portal_v2/getContacts';

    return axios({
      method: "post",
      url: url,
      data: {
        "referurl": url,
        "var2": sessionStorage.getItem("contract_id")
      },
      timeout: 5000,
      headers: {
        "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // Handle any errors that occur during the API request
      });
  }

  loadContacts = (siteIds) => {

    // console.log("Contacts Loading");

    this.loadContactsData(siteIds)
      .then(contactsData => {
        try {
          if (Array.isArray(contactsData)) {
            this.setState({ contacts: [...contactsData] });
          } else if (contactsData && typeof contactsData === 'object') {
            // Handle the case when contactsData is a single object, not an array
            this.setState({ contacts: [contactsData] });
          } else {
            // Handle the case when contactsData is not iterable
            console.error("contactsData is not iterable");
            this.setState({ contacts: [] }); // Set empty array to prevent crashes
          }
        } catch (error) {
          console.error("Error processing contacts data:", error);
          this.setState({ contacts: [] });
        }
      })
      .catch(error => {
        // Handle any errors that occur during the API request
        console.error("Error loading contacts:", error);
        this.setState({ contacts: [] }); // Set empty array to prevent crashes
      });

    // sessionStorage.setItem("contactsLoaded", 1);

  }

  loadBlogData = () => {
    let url = 'https://' + api_link + 'customer_portal_v2/getBlog';

    return axios({
      method: "post",
      url: url,
      data: {
        "referurl": url
      },
      timeout: 5000,
      headers: {
        "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // Handle any errors that occur during the API request
      });
  }

  loadBlog = () => {

    // console.log("Blog Loading");

    this.loadBlogData()
      .then(
        blogData => {
          this.setState({ blog: [...blogData] });
        }
      );
  }


  render() {

    return (
      <>
        <PanelHeader
          size="lg"
          content={image}
        />
        <div className="content" style={{ marginTop: '-270px' }}>


          {/*START - Stats Overview*/}
          <Row>
            <Col xs={12} md={12}>
              <Card className="card-stats card-raised">
                <CardHeader>
                  <CardTitle tag="h4">Jobs Overview</CardTitle>
                </CardHeader>
                <CardBody>
                  {this.state.stats && this.state.stats.map((stat, index) => {
                    return (
                      <Row key={index}>
                        {/* Open */}
                        <Col md="2">
                          <div className="statistics">
                            <div className="info">
                              <div className="icon icon-success">
                                <i className="now-ui-icons business_bulb-63" />
                              </div>
                              <h3 className="info-title"><NavLink to="/admin/joblist/logged">{stat.Open || 0}</NavLink></h3>
                              <h6 className="stats-title">Logged</h6>
                            </div>
                          </div>
                        </Col>
                        {/* Scheduled */}
                        <Col md="2">
                          <div className="statistics">
                            <div className="info">
                              <div className="icon icon-success">
                                <i className="now-ui-icons ui-2_time-alarm" />
                              </div>
                              <h3 className="info-title"><NavLink to="/admin/joblist/scheduled">{stat.Scheduled || 0}</NavLink></h3>
                              <h6 className="stats-title">Scheduled</h6>
                            </div>
                          </div>
                        </Col>
                        {/* En-Route */}
                        <Col md="2">
                          <div className="statistics">
                            <div className="info">
                              <div className="icon icon-success">
                                <i className="now-ui-icons location_compass-05" />
                              </div>
                              <h3 className="info-title"><NavLink to="/admin/joblist/enroute">{stat.EnRoute || 0}</NavLink></h3>
                              <h6 className="stats-title">En-Route</h6>
                            </div>
                          </div>
                        </Col>
                        {/* In Progress */}
                        <Col md="2">
                          <div className="statistics">
                            <div className="info">
                              <div className="icon icon-success">
                                <i className="now-ui-icons ui-2_settings-90" />
                              </div>
                              <h3 className="info-title"><NavLink to="/admin/joblist/inprogress">{stat.InProgress || 0}</NavLink></h3>
                              <h6 className="stats-title">Attended</h6>
                            </div>
                          </div>
                        </Col>
                        {/* Completed */}
                        <Col md="2">
                          <div className="statistics">
                            <div className="info">
                              <div className="icon icon-success">
                                <i className="now-ui-icons ui-1_check" />
                              </div>
                              <h3 className="info-title"><NavLink to="/admin/joblist/completed">{stat.Completed || 0}</NavLink></h3>
                              <h6 className="stats-title">Completed</h6>
                            </div>
                          </div>
                        </Col>
                        {/* Invoiced */}
                        <Col md="2">
                          <div className="statistics">
                            <div className="info">
                              <div className="icon icon-success">
                                <i className="now-ui-icons business_money-coins" />
                              </div>
                              <h3 className="info-title"><NavLink to="/admin/joblist/invoiced">{stat.Invoiced || 0}</NavLink></h3>
                              <h6 className="stats-title">Invoiced in {new Date().toLocaleDateString("en-GB", { month: "long" })}</h6>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    );
                  })
                  }
                </CardBody>
                <CardFooter>
                  <div className="stats float-right">
                    <i className="now-ui-icons arrows-1_refresh-69" onClick={() => this.componentDidMount()} />
                  </div>
                  <br />
                </CardFooter>
              </Card>
            </Col>
          </Row>
          {/*END - Stats Overview*/}


          <Row>
            {/*START - Blog*/}
            <Col xs={6} md={8}>
              <Card className="card-stats card-raised">
                <CardHeader>
                  <CardTitle tag="h4">JCW Blog</CardTitle>
                </CardHeader>
                <hr />
                {this.state.blog && this.state.blog.map((blog, index) => {
                  return (
                    <React.Fragment key={index}>
                      <CardBody>
                        <div className="statistics statistics-horizontal">
                          <div className="info info-horizontal">
                            <Row key={index}>
                              <Col xs="3">
                                <img src={blog.assetUrl} alt="..." />
                              </Col>
                              <Col className="text-left" xs="7">
                                <h5><a href={"https://www.jcwes.com" + blog.fullUrl} target="_blank" rel="noopener noreferrer">{blog.title}</a></h5>
                                <p style={{ margin: 0, padding: 0 }} >{blog.seoDescription}</p>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </CardBody>
                      <hr key={index} />
                    </React.Fragment>
                  );
                })}
              </Card>
            </Col>
            {/*END - Blog*/}


            {/*START - Your Contacts*/}
            <Col xs={6} md={4}>
              <Card className="card-stats card-raised">
                <CardHeader>
                  <CardTitle tag="h4">Your Contacts</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table>
                    <tbody>
                      {this.state.contacts && this.state.contacts.map((contact, index) => {
                        return (
                          <React.Fragment key={index}>
                          <tr>
                            <td style={{ width: '170px' }}>Account Manager</td>
                            <td>{contact.account_man ? contact.account_man : 'N/A'}</td>
                          </tr>
                          <tr>
                            <td>Helpdesk Phone</td>
                            <td>{contact.telephone_number ? contact.telephone_number : 'N/A'}</td>
                          </tr>
                          <tr>
                            <td>Helpdesk Email</td>
                            <td>
                            {contact.helpdesk_email ? (
                              <a href={`mailto:${contact.helpdesk_email}`}>{contact.helpdesk_email}</a>
                            ) : 'N/A'}
                            </td>
                          </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            {/*END - Your Contacts*/}


          </Row>

        </div>

      </>
    )

  }
}

export default Dashboard;